import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n              display: ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n              margin-bottom: ", ";\n\n              &:last-child {\n                  margin-bottom: 0;\n              }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typography } from '../mixins';
var variantToComponent = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'p',
  body2: 'p',
  body3: 'p',
  action: 'div',
  action1: 'div',
  action2: 'div'
};

var gutter = function gutter(_ref) {
  var gutterBottom = _ref.gutterBottom,
      variant = _ref.variant,
      typography = _ref.theme.typography;
  return gutterBottom ? css(_templateObject(), typeof gutterBottom === 'number' ? "".concat(gutterBottom, "px") : typography[variant].lineHeight) : null;
};

var display = function display(_ref2) {
  var display = _ref2.display;
  return display ? css(_templateObject2(), display) : null;
};

var color = function color(_ref3) {
  var color = _ref3.color,
      palette = _ref3.theme.palette;

  if (!color) {
    return;
  }

  var value = 'inherit';

  switch (color) {
    case 'primary':
      {
        value = palette.common.black;
        break;
      }

    case 'gray900':
      {
        value = palette.gray.gray900;
        break;
      }

    case 'error':
      {
        value = palette.error.main;
        break;
      }

    case 'warning':
      {
        value = palette.warning.main;
        break;
      }
  }

  return css(_templateObject3(), value);
};

var ellipsis = function ellipsis(_ref4) {
  var ellipsis = _ref4.ellipsis;
  return ellipsis ? css(_templateObject4()) : null;
};

var StyledTypography = styled.p(_templateObject5(), function (_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return typography(variant)({
    theme: theme
  });
}, display, gutter, ellipsis, color);
export var Typography = forwardRef(function (_a, ref) {
  var _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'body1' : _a$variant,
      _a$gutterBottom = _a.gutterBottom,
      gutterBottom = _a$gutterBottom === void 0 ? false : _a$gutterBottom,
      _a$ellipsis = _a.ellipsis,
      ellipsis = _a$ellipsis === void 0 ? false : _a$ellipsis,
      component = _a.component,
      children = _a.children,
      props = __rest(_a, ["variant", "gutterBottom", "ellipsis", "component", "children"]);

  return React.createElement(StyledTypography, Object.assign({}, props, {
    ref: ref,
    variant: variant,
    gutterBottom: gutterBottom,
    ellipsis: ellipsis,
    as: component || variantToComponent[variant]
  }), children);
});
Typography.displayName = 'Typography';